$(function(){
  new Swiper('.three-commitment-slide-mobile', {
    slidesPerView: 2,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  });

  var mobile_product_slider;

  function set_mobile_product_slider(screensize) {
    if(typeof mobile_product_slider !== 'undefined') {
      return
    }

    if(screensize < 750 ){
      mobile_product_slider = new Swiper('.product-image__mobile', {
        slidesPerView: 1,
        spaceBetween: 40,
        mousewheel: false,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      });
    }
  }

  var $window = $(window);

  set_mobile_product_slider($window.width());
  $window.on('resize', function(){
    set_mobile_product_slider($window.width());
  })

  $('.product-card').on('click', function(){
    var href = $(this).data('href');
    window.location = href;
  });

  $('.product-thumbnails').on('click', '.product-thumbnail', function(e){
    $('.product-thumbnail').removeClass('active');
    var $this = $(this);
    var $target = $('.product-image__main');

    if($this.data('video')) {
      $target.find('img').hide();
      $target.find('.video-wrapper').show();
      $('.product-image__main').trigger('zoom.destroy');
    } else {
      var src = $this.find('img').attr('src');
      $target.find('img').attr('src', src);
      $target.find('.video-wrapper').hide();
      $target.find('img').show();
      $('#shopify-section-single-product-page .product-image__main').zoom();
      
      if ($(window).width() >= 767) {     
      $('#shopify-section-single-product-variant-page-new .product-image__main').zoom();
      }
    }

    $this.addClass('active');
  })

  $('.customer-queries-question').on('click', function(){    
    if($(this).hasClass('active')) {
      $this = $(this);
      $this.next('.customer-queries-answer').hide();
      $this.removeClass('active');
    } else {
      $this = $(this);
      $('.customer-queries-answer').hide();
      $('.customer-queries-question').removeClass('active');
      $this.next('.customer-queries-answer').show();
      $this.addClass('active');
    }
  });

  
  $('#shopify-section-single-product-page .product-image__main').zoom();
  
  if ($(window).width() >= 767) {     
    $('#shopify-section-single-product-variant-page-new .product-image__main').zoom();
  }

  $('.variant-radio-input').on('click', function(e){
    var id = $(this).val()
    $('.alias-variant-raio-button').val(id);
  })
  
    
//   Customer feedback carousel 
  
    $('.shopify-section.customer-feedback-2 .slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      arrows: false,
      dots: true
    });
  
    $('.shopify-section.customer-feedback-2 .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){     
        thisIndex = nextSlide/3;
      if ($(window).width() > 767) {
        $('a.feedback-button').removeClass('active');
        $('a.feedback-button').eq(thisIndex).addClass('active'); 
      }
      
      if ($(window).width() <= 767) {
        $('a.feedback-button').removeClass('active');
        $('a.feedback-button').eq(thisIndex).addClass('active');
        $('ul.dropdown-mobile li').removeClass('tagDropdown');
        $('ul.dropdown-mobile li').eq(thisIndex).addClass('tagDropdown'); 
      }
  });
  
    if ($(window).width() > 767) {
      $('.customer-feedback .button-container a.feedback-button').on('click', function(e){
        e.preventDefault();
        thisIndex = $(this).parent('li').index();
        console.log(thisIndex);
        $('ul.slick-dots li').eq(thisIndex).children('button').trigger('click');        
       });
    }
  
// Customer feedback mobile dropdown - non-slider  
  
    if ($(window).width() <= 767) {        
   
        $('body').on('click', '.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown', function() {     
          if($('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').hasClass('active')) {
               $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').siblings().removeClass('active');          
               $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('active');
               $('.shopify-section.customer-feedback-2 .overlayClick').removeClass('active');
          } else {
              $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').siblings().addClass('active');
              $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').addClass('active');  
              $('.shopify-section.customer-feedback-2 .overlayClick').addClass('active'); 
          }
        });

        $('.shopify-section.customer-feedback-2 .customer-feedback .button-container a.feedback-button').on('click', function(e){
          e.preventDefault();
          $('.shopify-section.customer-feedback-2 a.feedback-button').removeClass('active');
          $('.shopify-section.customer-feedback-2 .feedback-block').removeClass('active');         

          if($(this).hasClass('quality')) {
            $('.shopify-section.customer-feedback-2 .feedback-block.quality').addClass('active');
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('tagDropdown');  
            $(this).parents('ul.dropdown-mobile li').addClass('tagDropdown');             
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').removeClass('perfect-gift').removeClass('exceeded').removeClass('design').removeClass('advertised');
            $('.shopify-section.customer-feedback-2 .shopify-section.customer-feedback-2 .customer-review-mobile-next').addClass('quality');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').text('Perfect Gift >>');
          }

          if($(this).hasClass('perfect-gift')) {
            $('.shopify-section.customer-feedback-2 .feedback-block.perfect').addClass('active');
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('tagDropdown');  
            $(this).parents('ul.dropdown-mobile li').addClass('tagDropdown');  
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').removeClass('quality').removeClass('exceeded').removeClass('design').removeClass('advertised');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').addClass('perfect-gift');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').text('As Advertised >>');
          }

          if($(this).hasClass('advertised')) {
            $('.shopify-section.customer-feedback-2 .feedback-block.advertised').addClass('active');
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('tagDropdown');  
            $(this).parents('ul.dropdown-mobile li').addClass('tagDropdown');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').removeClass('quality').removeClass('exceeded').removeClass('design').removeClass('perfect-gift');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').addClass('advertised');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').text('Craftmanship >>');
          }

          if($(this).hasClass('design')) {
            $('.shopify-section.customer-feedback-2 .feedback-block.design').addClass('active');
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('tagDropdown');  
            $(this).parents('ul.dropdown-mobile li').addClass('tagDropdown');  
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').removeClass('quality').removeClass('exceeded').removeClass('advertised').removeClass('perfect-gift');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').addClass('design');
          }  
          if($(this).hasClass('expectations')) {
            $('.shopify-section.customer-feedback-2 .feedback-block.expectations').addClass('active'); 
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li.tagDropdown').removeClass('tagDropdown');  
            $(this).parents('ul.dropdown-mobile li').addClass('tagDropdown'); 
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').removeClass('quality').removeClass('design').removeClass('advertised').removeClass('perfect-gift');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').addClass('exceeded');
            $('.shopify-section.customer-feedback-2 .customer-review-mobile-next').text('Quality customer service >>');
          } 
          $(this).addClass('active');  
          $('.shopify-section.customer-feedback-2 .overlayClick').removeClass('active');
          })
        
          $('body').on('click', '.shopify-section.customer-feedback-2 .customer-review-mobile-next.exceeded', function() {                                    
             $('.shopify-section.customer-feedback-2 .customer-feedback .button-container a.feedback-button.quality').trigger('click');
             $(this).removeClass('exceeded').addClass('quality');
             $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li').removeClass('active'); 
             $('html, body').animate({ scrollTop: $('.shopify-section.customer-feedback-2 .grid.three-reviews.mobile').offset().top - 65}, 500);         
          })
          
          $('body').on('click', '.shopify-section.customer-feedback-2 .customer-review-mobile-next.quality', function() {                                            
             $('.shopify-section.customer-feedback-2 .customer-feedback .button-container a.feedback-button.perfect-gift').trigger('click');
             $(this).removeClass('quality').addClass('perfect-gift');
             $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li').removeClass('active'); 
             $('html, body').animate({ scrollTop: $('.shopify-section.customer-feedback-2 .grid.three-reviews.mobile').offset().top - 65}, 500);         

          })
          $('body').on('click', '.shopify-section.customer-feedback-2 .customer-review-mobile-next.perfect-gift', function() {                                               
             $('.shopify-section.customer-feedback-2 .customer-feedback .button-container a.feedback-button.advertised').trigger('click');
             $(this).removeClass('perfect-gift').addClass('advertised');
             $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li').removeClass('active'); 
             $('html, body').animate({ scrollTop: $('.shopify-section.customer-feedback-2 .grid.three-reviews.mobile').offset().top - 65}, 500);         
          })
          $('body').on('click', '.shopify-section.customer-feedback-2 .customer-review-mobile-next.advertised', function() {                                             
             $('.shopify-section.customer-feedback-2 .customer-feedback .button-container a.feedback-button.design').trigger('click');
             $(this).removeClass('advertised').addClass('design');
             $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li').removeClass('active'); 
             $('html, body').animate({ scrollTop: $('.shopify-section.customer-feedback-2 .grid.three-reviews.mobile').offset().top - 65}, 500);         
          })
          
          $('.shopify-section.customer-feedback-2 .overlayClick').on('click', function(e){
            $('.shopify-section.customer-feedback-2 ul.dropdown-mobile li').removeClass('active'); 
      $(this).removeClass('active');
          })
       }
  
//   Sticky Header 
  
    $(window).scroll(function () {
        var sc = $(window).scrollTop()      
        if (sc > 90) {
          $('body.template-product .sticky-banner-desktop').addClass('scrolled');
          $('body.template-product .sticky-banner-mobile-top').addClass('scrolled');
        } else {
          $('body.template-product .sticky-banner-desktop').removeClass('scrolled');
          $('body.template-product .sticky-banner-mobile-top').removeClass('scrolled');
        }
    });
  
    $(window).scroll(function () {
          var scb = $(window).scrollTop()      
          if (scb > 700) {
            $('body.template-product .sticky-banner-mobile-bottom').addClass('scrolled');
          } else {
            $('body.template-product .sticky-banner-mobile-bottom').removeClass('scrolled');
          }
      });
  
    $('a.reviews-sticky').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({ scrollTop: $('#shopify-section-reviews-new').offset().top - 115}, 500);
    });
  
  
    $('.sticky-chef-card').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({ scrollTop: $('#shopify-section-chef-testimonial').offset().top - 115}, 500);
    });
  
//   Our commitment accordion 
    if ($(window).width() > 767) {
       $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.desktop').on('click', function(e){
         e.preventDefault();
         thisIndex=$(this).index();
         console.log(thisIndex);
         if($(this).hasClass('active')) {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').eq(thisIndex).hide();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').eq(thisIndex).children('.feedback-block').hide();
           $(this).removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.desktop').removeClass('down-hide'); 
         } else {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').hide();
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.desktop').removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').eq(thisIndex).show();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').eq(thisIndex).children('.feedback-block').show();
           $(this).addClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.desktop').addClass('down-hide');       
         }     
       });
      
      $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop span.our-commitment-desktop-next').on('click', function(e){
        e.preventDefault;
        totalBlocks = $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').length;
        totalBlocks = totalBlocks;
        currentIndex=$(this).parents('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.desktop').index();
        console.log(currentIndex);
        if(currentIndex == totalBlocks) {
            nextIndex = 0;
        } else {
          nextIndex = currentIndex;
        }
        console.log(nextIndex);
        $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.desktop').eq(nextIndex).trigger('click');
      });
      
    } else {
      $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').on('click', function(e){
         e.preventDefault();
         thisIndex=$(this).index();
         console.log(thisIndex);
         if($(this).hasClass('active')) {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').eq(thisIndex).hide();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').eq(thisIndex).children('.feedback-block').hide();
           $(this).removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').removeClass('down-hide'); 
         } else {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').hide();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').hide();
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').eq(thisIndex).show();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').eq(thisIndex).children('.feedback-block').show();
           $(this).addClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').addClass('down-hide');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').removeClass('down-hide'); 
         }     
       }); 
      
      $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block span.our-commitment-mobile-one-next').on('click', function(e){
        e.preventDefault;
        thisIndex=$(this).parents('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').index();
        console.log(thisIndex);
        if(thisIndex == 2) {
          $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').eq(1).trigger('click');
          $('html, body').animate({ scrollTop: $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').offset().top - 65}, 500);         
        } else if(thisIndex == 3) {
          $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').eq(0).trigger('click');
          $('html, body').animate({ scrollTop: $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').offset().top - 65}, 500);         
        }        
      });
      
       $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').on('click', function(e){
         e.preventDefault();
         thisIndex=$(this).index();
         if($(this).hasClass('active')) {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').eq(thisIndex).hide();
           $(this).removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').removeClass('down-hide'); 
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').eq(thisIndex).children('.feedback-block').hide();
         } else {
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').hide();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.first-block').hide();
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').removeClass('active');
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').eq(thisIndex).show();
           $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').eq(thisIndex).children('.feedback-block').show();
           $(this).addClass('active');
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').addClass('down-hide'); 
           $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').removeClass('down-hide');       
         }     
       }); 
      
      $('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block span.our-commitment-mobile-two-next').on('click', function(e){
        e.preventDefault;
        thisIndex=$(this).parents('#shopify-section-our-commitment-reviews .grid.three-reviews.commitment.second-block').index();
        console.log(thisIndex);
        if(thisIndex == 5) {
          $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').eq(1).trigger('click');
          $('html, body').animate({ scrollTop: $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.second-block').offset().top - 65}, 500);         
        } else if(thisIndex == 6) {
          $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').eq(0).trigger('click');
          $('html, body').animate({ scrollTop: $('#shopify-section-our-commitment-reviews .grid__item.commitment-block.first-block').offset().top - 65 }, 500);         
        }        
      });
    }

});

